<template>
  <div>
    <navbar
      :items="navbarItems"
      :fonticon="pageIcon"
      :navbartitle="pageTitle"
      :navbardescription="pageDescription"
    />
    <div class="notifications-table-widget">
      <div class="widget-heading">
        
      </div>
      <div class="widget-content">
        <div class="table-responsive">
          <div class="row"  style="margin-bottom: 10px;">
            <div class="col-4">
              <input
                type="text"
                class="form-control"
                placeholder="Search"
                v-model="search"
                @keyup.enter="setSearch"
              />
            </div>
            <div class="col-2">
              <select class="form-control" v-model="filter">
                <option value="all">All</option>
                <option value="read">Read</option>
                <option value="unread">Unread</option>
                <option value="archived">Archived</option>
              </select>
            </div>
            <div class="col-6 text-right actions">
              <a href="javascript:void(0)" class="btn btn-outline-danger btn-sm" @click.prevent="deleteAllMyNotifications">
                Supprimer toutes mes notifications
              </a>
              <a v-if="is_super_admin" class="btn btn-outline-secondary btn-sm" href="javascript:void(0)" @click.prevent="setAllAsRead">
                Set ALL as Read
              </a>
              <a v-if="is_super_admin" class="btn btn-outline-danger btn-sm" href="javascript:void(0)" @click.prevent="deleteAllNotification">
                Delete ALL Notification
              </a>
            </div>
          </div>
          <table class="table table-hover">
            <thead>
              <tr>
                <th>
                  <div class="th-content">
                    Source
                  </div>
                </th>
                <th>
                  <div class="th-content">
                    Message
                  </div>
                </th>
                <th>
                  <div class="th-content">
                    Time
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <notification-tr
                v-for="(n, index) in sortedNotifications"
                :key="index"
                :notification="n"
                v-if="visibleRow(index, n)"
              />
            </tbody>
          </table>
        </div>
        <div class="row pied-list">
          <div class="col-md-2">
            <span class="stat">Page: <strong>{{ currentPage }}/{{ pages }}</strong></span>
          </div>
          <div class="col-md-2">
            <span class="stat"><strong> {{ from + 1 }} - {{ offset }}/{{ total }}</strong></span>
          </div>
          <div class="col-md-8 navigation">
            <v-pagination
              v-model="currentPage"
              :page-count="pages"
              :classes="bootstrapPaginationClasses"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex'
import moment from 'moment'
import vPagination from 'vue-plain-pagination'
import Navbar from '../components/navbar.vue'
import NotificationTr from '../components/user/notificationTr.vue'
import { SET_ALL_NOTIFICATION_AS_READ, DELETE_ALL_NOTIFICATION, DELETE_ALL_MY_NOTIFICATION, SET_NOTIFICATION_AS_READ } from '../graphql/user';
export default {
    components: {Navbar, NotificationTr, vPagination},
    data() {
        return {
          navbarItems: [ { libelle: 'Notification' } ],
            pageIcon: 'la-rocketchat',
            pageTitle: 'Notification',
            pageDescription: 'Discussion instantanée', 
            search: '',
            filter: 'all',
            timeout: null,
            sortedNotifications: [],
            currentPage: 1,
            userperapge: null,
            from: 0,
        }
    },
    watch: {
      search(){
        if (this.search.length > 1) {
          clearTimeout(this.timeout)
          this.timeout = setTimeout(() => {
            this.sortedNotifications = this.notifications.filter(item => this.$options.filters.deepSearch(item, this.search))
            this.$emit('search', {search: this.search})
          }, 500)
        }else{
          this.sortedNotifications = [...this.notifications].sort((b,a) => moment(a.createdAt).format('X') - moment(b.createdAt).format('X'))
        }
      },
      filter() {
        this.filtring()
      },
      notifications: {
        handler() {
          this.filtring()
        },
        deep: true
      },
      currentPage () {
        this.from = this.perpage * (this.currentPage - 1)
      },
    },
    methods: {
      ...mapMutations({
        setAsReadNotification: 'notification/DEFINE_NOTIFICATION_AS_READ'
      }),
      filtring(){
        if(this.filter === 'all') {
          this.sortedNotifications = [...this.notifications].sort((b,a) => moment(a.createdAt).format('X') - moment(b.createdAt).format('X'))
        }else if(this.filter === 'read') {
          this.sortedNotifications = [...this.notifications].filter(item => item.read).sort((b,a) => moment(a.createdAt).format('X') - moment(b.createdAt).format('X'))
        }else if(this.filter === 'unread') {
          this.sortedNotifications = [...this.notifications].filter(item => !item.read).sort((b,a) => moment(a.createdAt).format('X') - moment(b.createdAt).format('X'))
        }else if(this.filter === 'archived') {
          this.sortedNotifications = [...this.notifications].filter(item => item.archive).sort((b,a) => moment(a.createdAt).format('X') - moment(b.createdAt).format('X'))
        }
      },
      visibleRow (index, notification) {
        const visible = !((index) < this.from) && !(index + 1 > this.offset)
        if(!notification.read && visible){
          this.$apollo.mutate({
            mutation: SET_NOTIFICATION_AS_READ,
            variables: {
              uid: notification.uid
            },
            update: (cache, { data: { setNotificationAsRead } }) => {
              console.log(setNotificationAsRead);
              this.setAsReadNotification(notification);
            }
          });
        }
        return visible
      },

      setAllAsRead() {
        this.$apollo.mutate({
            mutation: SET_ALL_NOTIFICATION_AS_READ,
            update: () => {
                console.log(`Done successfully!`)
            }
          }).catch((error) => {
            console.error(error)
        })
      },
      deleteAllNotification() {
        this.$apollo.mutate({
            mutation: DELETE_ALL_NOTIFICATION,
            update: () => {
                console.log(`Done successfully!`)
            }
          }).catch((error) => {
            console.error(error)
        })
      },
      deleteAllMyNotifications() {
        this.$apollo.mutate({
            mutation: DELETE_ALL_MY_NOTIFICATION,
            update: () => {
                console.log(`Done successfully!`)
            }
          }).catch((error) => {
            console.error(error)
        })
      }
    },
    computed: {
      ...mapGetters({
        notifications: 'notification/notifications',
        is_super_admin: 'auth/is_super_admin',
        perpage: 'options/itemsPerpage',
      }),
      bootstrapPaginationClasses () {
        return {
          ul: 'pagination',
          li: 'page-item',
          liActive: 'active-page',
          liDisable: 'disabled',
          button: 'page-link'
        }
      },
      pages () {
        if (this.total > 0) { return Math.ceil(this.total / this.perpage) }
        return 1
      },
      total () {
        if (this.sortedNotifications !== null && this.sortedNotifications instanceof Array) { return this.sortedNotifications.length }
        return 0
      },
      offset () {
        if (this.total > 0) {
          let result = this.from + this.perpage
          if (result > this.total) return this.total
          return result
        }
        return 0
      }
    }
}
</script>